export const AIResearchFutureConfig = {
    "airesearch.**": {
        url: "/digitalsuite/ai-research",
        lazyLoad: () => import("./AIResearchConfig"),
    },
};
